import {InjectableClass} from '@fino/lib-injection/index';
import _ from 'lodash';

export class CreateRequestModalActionService extends InjectableClass {
  constructor(
    appCache,
    duplicateDialogBody,
    needsConfirmationService) {
    'ngInject';
    super({
      appCache,
      duplicateDialogBody,
      needsConfirmationService});
  }

  showNothingIncludedDialog(controller, model, ticketId) {

    if (this.hasNothingToInclude(model)) {
      // prepare confirmation dialog
      _.defaults(controller.$scope, {
        confirmTitle: 'app.receiving.createRequest.noPartnerIncluded.modal.title',
        confirmBody: 'app.receiving.createRequest.noPartnerIncluded.modal.body',
        confirmDismiss: 'app.receiving.createRequest.noPartnerIncluded.modal.dismiss',
        confirmOk: 'app.receiving.createRequest.noPartnerIncluded.modal.confirm'
      });

      // show dialog uiModalDeclarationService
      this.needsConfirmationService.open({
        onSuccess: () => {
          controller.submitTicket(model, ticketId);
        },
        scope: controller.$scope
      });

      return true;
    }

    return false;
  }

  hasNothingToInclude(model) {
    return model.toggleIncludeAllDebitsPartner === 'inculdeNothingDebitsPartner'
      && model.toggleIncludeAllDepositsPartner === 'inculdeNothingDepositsPartner'
      && model.toggleIncludeAllStandingOrders === 'inculdeNothingStandingOrders';
  }

  showDuplicatedTicketDialog(controller, model, ticketId, duplicates) {

    controller.ibans = [model.newIban, model.oldIban];

    controller.hasBranchId = false;

    controller.duplicates = _.forEach(duplicates, (element) => {
      if (element.branchId) {
        controller.hasBranchId = true;
      }
      element.urlToTicket = 'tickets/' + element.id;
    });

    // prepare confirmation dialog
    _.defaults(controller.$scope, {
      confirmTitle:   'app.receiving.createRequest.duplicates.modal.title',
      confirmBodyUrl: this.duplicateDialogBody,
      confirmDismiss: 'app.receiving.createRequest.duplicates.modal.dismiss',
      confirmOk:      'app.receiving.createRequest.duplicates.modal.confirm',
      confirmSpecialAction: 'app.receiving.createRequest.duplicates.modal.confirmSpecialAction',
      specialAction: ($modal) => {
        // true because we just want to close the modal
        $modal.dismiss(true);
      }
    });

    // show dialog uiModalDeclarationService
    this.needsConfirmationService.open({
      onSuccess: () => {
        // this is a force commit!!!
        controller.submitTicket(model, ticketId, true);
      },
      onDismiss: (transition) => {
        if (!transition) {
          controller.go('app.receiving.list');
        }
      },
      size: 'lg',
      scope: controller.$scope
    });

    return true;
  }
}
